(function () {
  'use strict';

  const transparentPixel = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';

  function resolveSizes(image) {
    const configuredSizes = image.dataset.deferredSizes;
    if (configuredSizes && configuredSizes !== 'auto') return configuredSizes;
    const renderedWidth = Math.max(1, Math.ceil(image.getBoundingClientRect().width));
    return renderedWidth + 'px';
  }

  function revealImage(image) {
    if (!image || image.dataset.deferredLoaded === 'true') return;

    image.dataset.deferredLoaded = 'true';
    image.sizes = resolveSizes(image);

    const picture = image.closest('picture');
    if (picture) {
      picture.querySelectorAll('source[data-deferred-srcset]').forEach(function (source) {
        source.srcset = source.dataset.deferredSrcset;
        source.removeAttribute('data-deferred-srcset');
      });
    }

    if (image.dataset.deferredSrcset) {
      image.srcset = image.dataset.deferredSrcset;
    }
    if (image.dataset.deferredSrc) {
      image.src = image.dataset.deferredSrc;
    }

    image.addEventListener('load', function () {
      image.classList.add('is-loaded');
      image.closest('.product-featured-image')?.classList.add('hover-image-ready');
    }, { once: true });

    if (image.complete && image.currentSrc && image.currentSrc !== transparentPixel) {
      image.classList.add('is-loaded');
      image.closest('.product-featured-image')?.classList.add('hover-image-ready');
    }
  }

  window.themeRevealDeferredImage = revealImage;

  const visibleObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          revealImage(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '160px 80px' })
    : null;

  function watchVisibleImages(root) {
    const scope = root || document;
    const images = [];
    if (scope.matches && scope.matches('img[data-defer-mode="visible"]:not([data-deferred-watched])')) images.push(scope);
    scope.querySelectorAll('img[data-defer-mode="visible"]:not([data-deferred-watched])').forEach(function (image) {
      images.push(image);
    });
    images.forEach(function (image) {
      image.dataset.deferredWatched = 'true';
      if (visibleObserver) {
        visibleObserver.observe(image);
      } else {
        revealImage(image);
      }
    });
  }

  function reserveImageDimensions(root) {
    const scope = root || document;
    const images = [];
    if (scope.matches && scope.matches('img:not([width]), img:not([height])')) images.push(scope);
    scope.querySelectorAll('img:not([width]), img:not([height])').forEach(function (image) {
      images.push(image);
    });
    images.forEach(function (image) {
      const setDimensions = function () {
        if (!image.getAttribute('width') && image.naturalWidth) image.setAttribute('width', image.naturalWidth);
        if (!image.getAttribute('height') && image.naturalHeight) image.setAttribute('height', image.naturalHeight);
      };
      if (image.complete) setDimensions();
      else image.addEventListener('load', setDimensions, { once: true });
    });
  }

  function initialize(root) {
    watchVisibleImages(root);
    reserveImageDimensions(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialize(document); }, { once: true });
  } else {
    initialize(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });

  const appObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) initialize(node);
      });
    });
  });

  if (document.body) appObserver.observe(document.body, { childList: true, subtree: true });
  else document.addEventListener('DOMContentLoaded', function () {
    appObserver.observe(document.body, { childList: true, subtree: true });
  }, { once: true });

  window.setTimeout(function () { appObserver.disconnect(); }, 30000);
})();
